var url, googleApiKey, wsUrl, wsPrefix, webAppUrl, stripeKey

if (process.env.REACT_APP_QA === 'qa') {
  url = 'https://airtouch.hyperether.com'
  googleApiKey = 'AIzaSyB9fmsHujvPzXiruMlQV1nEXt-VGUKegMI'
  wsUrl = 'wss://socket.hyperether.com'
  webAppUrl = 'https://airtouch-app.hyperether.com'
  wsPrefix = 'airtouchqa'
  stripeKey =
    'pk_test_51OHv2ECW7pqCNm1B74Tnq02HHFhSVWWPJQrCYm1UqepFpTsXHYx7zuw4N3GLsGgYVdas24K615W6KkkgaUqJjCnN00TFIRoW9b'
} else if (process.env.REACT_APP_PROD === 'prod') {
  url = 'https://api.ai-mobility.biz'
  googleApiKey = 'AIzaSyB9fmsHujvPzXiruMlQV1nEXt-VGUKegMI'
  webAppUrl = 'https://meet.ai-mobility.biz'
  wsUrl = 'wss://socket.hyperether.com'
  wsPrefix = 'airtouchqa'
  stripeKey =
    'pk_live_51OHv2ECW7pqCNm1BlGbGgHMN0VogiIWTWSzfMVwVmiTk8sfa7LG60R203MFqobv6cG0oR904jNJxrUhk0oBUnwUZ00985bUrow'
} else if (process.env.REACT_APP_DEV === 'dev') {
  url = 'http://localhost:3000'
  webAppUrl = 'http://localhost:3002'
  googleApiKey = 'AIzaSyB9fmsHujvPzXiruMlQV1nEXt-VGUKegMI'
  wsUrl = 'wss://socket.hyperether.com'
  wsPrefix = 'airtouchqa'
  stripeKey =
    'pk_test_51OHv2ECW7pqCNm1B74Tnq02HHFhSVWWPJQrCYm1UqepFpTsXHYx7zuw4N3GLsGgYVdas24K615W6KkkgaUqJjCnN00TFIRoW9b'
} else if (process.env.NODE_ENV === 'development') {
  url = 'http://localhost:3000'
  webAppUrl = 'http://localhost:3002'
  googleApiKey = 'AIzaSyB9fmsHujvPzXiruMlQV1nEXt-VGUKegMI'
  wsUrl = 'wss://socket.hyperether.com'
  wsPrefix = 'airtouchqa'
  stripeKey =
    'pk_test_51OHv2ECW7pqCNm1B74Tnq02HHFhSVWWPJQrCYm1UqepFpTsXHYx7zuw4N3GLsGgYVdas24K615W6KkkgaUqJjCnN00TFIRoW9b'
} else {
  url = 'http://localhost:3000'
  webAppUrl = 'http://localhost:3002'
  googleApiKey = 'AIzaSyB9fmsHujvPzXiruMlQV1nEXt-VGUKegMI'
  wsUrl = 'wss://socket.hyperether.com'
  wsPrefix = 'airtouchqa'
  stripeKey =
    'pk_test_51OHv2ECW7pqCNm1B74Tnq02HHFhSVWWPJQrCYm1UqepFpTsXHYx7zuw4N3GLsGgYVdas24K615W6KkkgaUqJjCnN00TFIRoW9b'
}

export default url
export { googleApiKey, wsUrl, wsPrefix, webAppUrl, stripeKey }
